import { AuditoriaService } from './../services/auditoria.service';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Auditoria } from '../models/auditoria';
import { TipoOperacion } from '../enum/enumTipoOperacion';

@Injectable({
    providedIn: 'root'
})
export class AuditoriaInterceptor implements HttpInterceptor {
    constructor(private auditoriaService: AuditoriaService ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const objAuditoria = new Auditoria(
            window.sessionStorage.getItem('idSolicitud') ? window.sessionStorage.getItem('idSolicitud') : ' ',
            JSON.parse(window.sessionStorage.getItem('informacionbasica')) ?
            JSON.parse(window.sessionStorage.getItem('informacionbasica')).numeroDocumento : ' ',
            TipoOperacion.Request, req);

        if (!req.url.includes('auditoria')) {
            if (objAuditoria.NumeroDocumento !== ' ') {
            this.auditoriaService.InsertarRegistro(objAuditoria).subscribe();
            }
        }

        return next.handle(req).pipe(
            tap(evt => {
                if (evt instanceof HttpResponse) {
                    objAuditoria.TipoOperacion = TipoOperacion.Response;
                    if (!req.url.includes('auditoria')) {
                        if (objAuditoria.NumeroDocumento !== ' ') {
                        this.auditoriaService.InsertarRegistro(objAuditoria).subscribe();
                        }
                    }
                }
             }),
            catchError(error => {
                objAuditoria.TipoOperacion = TipoOperacion.Error;
                if (!req.url.includes('auditoria')) {
                        if (objAuditoria.NumeroDocumento !== ' ') {
                        this.auditoriaService.InsertarRegistro(objAuditoria).subscribe();
                        }
                    }
                return throwError(error);
            })
        );
    }


}


